import { DefaultProjectorFn, MemoizedSelector, createSelector } from '@ngrx/store';

import { RefrigerationCircuitMessagesDataDetails } from '@vi-iot/client';

import { AppState } from '@store';

import { RefrigerationCircuitMessagesState } from './refrigeration-circuit-messages.state';

export namespace RefrigerationCircuitMessagesSelectors {
  export const refrigerationCircuitMessagesState = (
    state: AppState
  ): RefrigerationCircuitMessagesState => state.refrigerationCircuitMessages;

  export const getLoadingIndicator = createSelector(
    refrigerationCircuitMessagesState,
    (state: RefrigerationCircuitMessagesState): boolean => state?.loading
  );

  export function getRefrigerationCircuitMessages(
    gatewaySerial
  ): MemoizedSelector<
    AppState,
    RefrigerationCircuitMessagesDataDetails[],
    DefaultProjectorFn<RefrigerationCircuitMessagesDataDetails[]>
  > {
    return createSelector(
      refrigerationCircuitMessagesState,
      (state: RefrigerationCircuitMessagesState): RefrigerationCircuitMessagesDataDetails[] => {
        const messages = state.messages?.find((entry) => entry.gateway_id === gatewaySerial)?.data;

        return messages;
      }
    );
  }
}
